import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetPagoUnicoCATAByID from "services/record/PagoUnicoCATA/useGetPagoUnicoCATAByID";
import useGetInfoPagoUnicoCATA from "services/record/PagoUnicoCATA/useGetInfoPagoUnicoCATA";
import useGetPagoUnicoCATAByUser from "services/record/PagoUnicoCATA/useGetPagoUnicoCATAByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import PagoUnicoCATA from "./PagoUnicoCATA";

const GridPagoUnicoCATA = ({ expedienteId = null, origen = null }) => {

    const {
        getPagoUnicoCATAByID,
        loadingGetPagoUnicoCATAByID,
        statusGetPagoUnicoCATAByID
    } = useGetPagoUnicoCATAByID();

    const {
        getInfoPagoUnicoCATA,
        loadingGetInfoPagoUnicoCATA,
        statusGetInfoPagoUnicoCATA
    } = useGetInfoPagoUnicoCATA();

    const {
        dataGetPagoUnicoCATAByUser,
        getPagoUnicoCATAByUser,
        loadingGetPagoUnicoCATAByUser,
        statusGetPagoUnicoCATAByUser
    } = useGetPagoUnicoCATAByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Pago único en cese de actividad en autónomos";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getPagoUnicoCATAByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetPagoUnicoCATAByID?.status) {
            setCurrentHttp({
                status: statusGetPagoUnicoCATAByID.status,
                statusText: statusGetPagoUnicoCATAByID.statusText
            });
        } else if (statusGetInfoPagoUnicoCATA?.status) {
            setCurrentHttp({
                status: statusGetInfoPagoUnicoCATA.status,
                statusText: statusGetInfoPagoUnicoCATA.statusText
            });
        } else if (statusGetPagoUnicoCATAByUser?.status) {
            setCurrentHttp({
                status: statusGetPagoUnicoCATAByUser.status,
                statusText: statusGetPagoUnicoCATAByUser.statusText
            });
        }
    }, [
        statusGetPagoUnicoCATAByID,
        statusGetInfoPagoUnicoCATA,
        statusGetPagoUnicoCATAByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getPagoUnicoCATAByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoPagoUnicoCATA(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetPagoUnicoCATAByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 1 || item.EstadoFormulario === 3);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetPagoUnicoCATAByUser]);

    const isLoading = () => {
        return (
            loadingGetPagoUnicoCATAByID ||
            loadingGetInfoPagoUnicoCATA ||
            (loadingGetPagoUnicoCATAByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetPagoUnicoCATAByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <PagoUnicoCATA
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getPagoUnicoCATAByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridPagoUnicoCATA;

